import { Card, Skeleton, Typography } from '@mui/material'
import react from 'react'

const LoadingSkeleton = () => {
    return (
        <Card style={{ margin: '3px auto', height: '100px',}} className={'reducedCard'}>
            <div style={{ display: 'flex', height: '100%', flexDirection: 'row', padding: '0 10px', justifyContent: 'space-between' }}>
                <div style={{ flex: 1, }}>
                    <Skeleton height='100%' width="100%" />
                </div>
                <div style={{ flex: 0.2 }}></div>
                <div id='titleSize'>
                    <Typography gutterBottom variant="p" style={{ fontWeight: '600', textAlign: 'start', flex: 2 }} component="div">
                        <Skeleton height='100%' width="100%" />
                    </Typography>
                    <div style={{ flex: 1 }}>
                        <Typography gutterBottom variant="p" style={{ textAlign: 'start', fontSize: '13px', color: '#B29E84' }} component="div">
                            <Skeleton height='100%' width="100%" />
                        </Typography>
                        <Typography gutterBottom variant="p" style={{ textAlign: 'start', fontSize: '13px', color: '#B29E84' }} component="div">
                            <Skeleton height='100%' width="100%" />
                        </Typography>
                    </div>
                </div>
            </div>
        </Card>
    )
}
export default LoadingSkeleton;